<template>
  <template v-if="type === 'pop-up' && !isMobile">
    <overlay
      key="bis-success-modal"
      direction="up"
      block-class="bis-success-modal"
      namespace="bis-success-modal"
      type="modal"
      :show-overlay="false"
      :show-close="false"
      :disable-scroll="false"
    >
      <template #body>
        <div
          class="klaviyo-bis-message"
        >
          <icon-check />

          <p
            class="
                klaviyo-bis-message__title
                text-body-2xs-regular
              "
            v-text="$string('product.bis_success_message')"
          />
        </div>
      </template>
    </overlay>
  </template>

  <template v-else>
    <div
      class="klaviyo-bis-message bis-mobile"
      :class="type"
    >
      <icon-check />

      <p
        class="
            klaviyo-bis-message__title
            text-body-2xs-regular
          "
        v-text="$string('product.bis_success_message')"
      />
    </div>
  </template>
</template>

<script>

/**
 * Vue: Klaviyo BIS Message (klaviyo-bis-message)
 * -----------------------------------------------------------------------------
 * Klaviyo BIS Message - pop-up.
 *
 */
import { mapActions, mapGetters, mapState } from 'vuex'
import Overlay from '~global/overlay/overlay'
import IconCheck from '~icons/general/check.svg'

export default {
  name: 'KlaviyoBisMessage',

  components: {
    IconCheck,
    Overlay,
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  watch: {
    getActiveOverlay() {
      if (this.getActiveOverlay && this.getActiveOverlay.namespace === 'bis-success-modal') {
        this.closeDelayed()
      }
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    /**
     * Close pop up with delay
     */
    closeDelayed() {
      setTimeout(() => {
        this.closeOverlay('bis-success-modal')
      }, this.$timing('message'))
    },
  },
}
</script>

<style lang="scss">
@import './klaviyo-bis-message';
</style>
